import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Button} from "reactstrap";

const BrandColumn = memo(({product}) => (
  <td className="url text-center">
    <a href={product.url} target="_blank">
      <Button color={'white'} className='btn-icon-only btn btn-primary'>
        <span className="fa-solid fa-up-right-from-square color-primary"/>
      </Button>
    </a>
  </td>
));

BrandColumn.propTypes = {
  product: PropTypes.object.isRequired,
  projectState: PropTypes.object.isRequired
};

export default BrandColumn;
